import { render, staticRenderFns } from "./ImportUploader.vue?vue&type=template&id=5a65a72d&"
import script from "./ImportUploader.vue?vue&type=script&lang=js&"
export * from "./ImportUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports